import React from "react";

interface HeaderProps {
  onMenuClick: () => void;
  onLogout: () => void;
}

const Header: React.FC<HeaderProps> = ({ onMenuClick, onLogout }) => {
  return (
    <nav className="h-[45px] bg-[#EA33C0] flex items-center px-2 shadow z-20">
      {/* Hamburger menu for mobile */}
      <div className="flex-none md:hidden">
        <button
          onClick={onMenuClick}
          aria-label="Open sidebar"
          className="flex items-center"
        >
          <svg
            className="h-8 w-8 text-white"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 6h16M4 12h16M4 18h16"
            />
          </svg>
        </button>
      </div>
      {/* Right side: Logout & MediaBridge */}
      <div className="flex-1 flex justify-end items-center">
        <button
          onClick={onLogout}
          className="text-white text-[20px] mr-4 hover:underline"
        >
          Logout
        </button>
        <h2 className="text-white text-[20px] font-bold ml-5">MediaBridge</h2>
      </div>
    </nav>
  );
};

export default Header;
